import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../../api';
import { showConfirm } from '../../utils/popup';

/**
 * Triggers Google Sheets student import. Shown on Admin / Manager / Coach student lists when enabled on server.
 */
export default function ImportStudentsButton({ onComplete, className = 'btn-page-action-accent' }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        const ok = await showConfirm(t('pages.studentImport.bulkImportConfirm'));
        if (!ok) return;

        setLoading(true);
        try {
            await API.post('/staff/student-import/trigger');
            alert(t('pages.studentImport.bulkImportTriggered'));
            onComplete?.();
        } catch (err) {
            console.error('Student import failed:', err);
            alert(
                apiErrorMessage(err, t('pages.studentImport.bulkImportFailed'))
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            disabled={loading}
            className={className}
            title={t('pages.studentImport.bulkImportTitle')}
        >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l4-4m0 0l4 4m-4-4v12" />
            </svg>
            {loading ? t('pages.studentImport.bulkImporting') : t('pages.studentImport.bulkImportButton')}
        </button>
    );
}
